import axios from 'axios';
import config from '../config/config';

const apiUrl = config.apiBaseUrl;

/**
 * Obtiene la tabla de Niveles de Autorizacion con paginacion server-side.
 */
export const getTablaNivelAut = async (payload, signal) => {
  try {
    const res = await axios.post(`${apiUrl}/nivelAutTabla`, payload, { signal });
    return res.data;
  } catch (err) {
    if (err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') throw err;
    throw new Error('Error al cargar datos de niveles de autorizacion.');
  }
};
